import api from '../../../../api/core';
import useGenericMutation from '../../../../api/react-query/use-generic-mutation';

export function useUpdateLeaveRule() {
  const params = { locale: localStorage.getItem('applang') };

  const {
    mutateAsync: updateLeaveRule,
    isLoading: isUpdating,
    error,
  } = useGenericMutation({
    func: ({ id, payload }) =>
      api.put(`v1/engine/rule/${id}`, payload, { params }),
    url: 'engine/rule',
    params,
    msg: 'Rule updated successfully',
  });

  return {
    updateLeaveRule,
    isUpdating,
    error,
  };
}
